import { PROFILE_URL, SIGNIN_URL, SIGNOUT_URL, SIGNUP_URL } from '@skynet/auth-feature';
import { botCommandsConfig } from '@skynet/admin-bot-commands-feature';
import { botMessagesConfig } from '@skynet/bot-messages-feature';
import { tradingGroupsConfig } from '@skynet/trading-groups-feature';
import { smmConfig } from '@skynet/smm-feature';
import { exchangesConfig } from '@skynet/exchanges-feature';
import { usersConfig } from '@skynet/users-feature';
import { regionsConfig } from '@skynet/regions-feature';
import { itemsConfig } from '@skynet/items-feature';
import { tenantsConfig } from '@skynet/tenants-feature';
import { rolesConfig } from '@skynet/roles-feature';
import { marketingConfig } from '@skynet/marketing-feature';
import { tokenMappingConfig } from '@skynet/token-mapping-feature';

// Paths contributed by feature-package configs that do not require a WebSocket
// login. Migrating a new feature moves its entries out of the static list below
// and into its own config's `skipWsLoginPaths`.
const featureSkipWsLoginPaths = [
  botCommandsConfig,
  botMessagesConfig,
  tradingGroupsConfig,
  smmConfig,
  exchangesConfig,
  usersConfig,
  regionsConfig,
  itemsConfig,
  tenantsConfig,
  rolesConfig,
  tokenMappingConfig,
  marketingConfig,
].flatMap((feature) => feature.skipWsLoginPaths ?? []);

const skipWsLoginPaths = [
  ...featureSkipWsLoginPaths,
  // Each entry covers its sub-paths: these two cover every sign-in / sign-up page.
  SIGNIN_URL,
  SIGNUP_URL,
  SIGNOUT_URL,
  // Also covers the sign-up 2FA alias at `PROFILE_2FA_URL`.
  PROFILE_URL,
  '/cookies',
  '/terms',
  '/dex',
];

/** Whether `pathname` is `path` itself or below it (`/signin/2fa`, not `/signin-help`). */
const isAtOrBelow = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);

export const requiresLoginCommand = (pathname: string) => {
  const normalized = pathname.toLowerCase();
  return !skipWsLoginPaths.some((path) => isAtOrBelow(normalized, path));
};
